import { OnInit, AfterViewInit, Directive } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup } from "@angular/forms";
import { AuthenticationService } from '../../services/authentication.service';


@Directive()
export abstract class BaseCrudUpdComponent implements OnInit, AfterViewInit {

  public rights: any;
  // record fields
  public editForm: FormGroup;
  public is_create: boolean;
  public record_id: string;
  public submitted = false;

  public links: any[];
  public title: string;

  /**
   * Allow HTML to use the form controls
   */
  public get form() { return this.editForm.controls; }


  constructor(protected router: Router,
    protected route: ActivatedRoute,
    protected formBuilder: FormBuilder,
    protected authenticationService: AuthenticationService) {
  }

  protected onGetLinks() {
    return null;
  }

  protected abstract onGetTitle(): string;

  ngOnInit() {
    this.rights = this.authenticationService.getUserRights();
    this.record_id = this.getRecordId();
    if ((!this.record_id) || (this.record_id == "null") || (this.record_id == "0"))
      this.record_id = null;
    this.is_create = !this.record_id;
    this.title = this.onGetTitle();
    this.links = this.onGetLinks();
    if (this.links)
      this.links.push({ label: this.title, path: '/.' });
    this.initializeForm();
  }

  ngAfterViewInit() {
    this.fillData(this.record_id);
  }

  protected abstract getRecordId(): string;
  protected abstract initializeForm(): void;
  protected abstract fillData(record_id: string): void;


  public hasRight(right: string): boolean {
    return (this.rights[right]) ? true : false;
  }

  public setError(field_name: string, error_name: string) {
    let error = {}
    error[error_name] = true;
    this.form[field_name].setErrors(error);
    this.submitted = true;
  }
}